import script from "./SimpleQuestionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleQuestionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleQuestionComponent.vue?vue&type=style&index=0&id=148067ff&lang=scss"

const __exports__ = script;

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup,QCheckbox});
